import { initFragmentOnClient } from 'lib/ssr-client-react'

import { dispatch } from 'common/pageBus'
import { PRODUCT_INFO_FRAGMENT_RENDERED } from 'client/pageBusEvents'
import { getFragmentState } from 'lib/ssr-client'
import fragment from './index'
import { createLogger } from 'common/log'

const logger = createLogger('fragments/productDetailsFragmentInfo/client')

const fragmentName = 'productDetailsFragmentInfo'

initFragmentOnClient(fragment.Component, fragmentName)
const preloadedState = getFragmentState(fragmentName)

const { userid } = preloadedState

dispatch({
  type: PRODUCT_INFO_FRAGMENT_RENDERED,
  props: preloadedState,
  userid
})

// DO NOT CHANGE UNLESS YOU REALLY KNOW WHAT YOU ARE DOING
initFragmentOnClient(fragment.Component, fragmentName)
if (module.hot) {
  module.hot.accept('./index', () => {
    logger.debug(`hot reloading ${fragmentName}`)
    const reload = require('./index').default
    initFragmentOnClient(reload.Component, fragmentName)
  })
}
